import { Box, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { getAssetsBaseUrl } from '../../../config/assetsUrl';
import AnimatedTypography from '../../core/AnimatedTypography';
import StaffMemberView from '../components/StaffMemberView';

const StaffMemberPage: React.FC = () => {
    const { t } = useTranslation();

    useEffect(() => {
        window?.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{t("seo.ourTeam.title")}</title>
                <meta name="description" content={t("seo.ourTeam.description")} />
                <link rel="canonical" href="https://enduro-connection-radusa.com/our-team/" />
                <meta property="og:title" content={t("seo.ourTeam.title")} />
                <meta property="og:description" content={t("seo.ourTeam.ogDescription")} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://enduro-connection-radusa.com/our-team/" />
            </Helmet>

            <Box pb={6} display="flex" flexDirection="column" gap={4}>
                <AnimatedTypography variant="h3" mt={2} mb={{ xs: 0, sm: 2 }} ml={1} color="text2.primary" fontWeight={600}>
                    {t('staffMember.title')}
                </AnimatedTypography>

                <Box display="flex" flexDirection="column" gap={{ xs: 4, md: 6 }}>
                    <StaffMemberView
                        name={t('staffMember.ivanRezo.title')}
                        pictureUrl={`${getAssetsBaseUrl()}/images/staff-member/ivan.jpg`}
                        description={
                            <Box display="flex" flexDirection="column" gap={2}>
                                <Typography>{t('staffMember.ivanRezo.1')}</Typography>
                                <Typography>{t('staffMember.ivanRezo.2')}</Typography>
                                <Typography>{t('staffMember.ivanRezo.3')}</Typography>
                                <Typography>{t('staffMember.ivanRezo.4')}</Typography>
                                <Typography>{t('staffMember.ivanRezo.5')}</Typography>
                            </Box>
                        }
                    />

                    <StaffMemberView
                        reverse
                        name={t('staffMember.stjepanSabljo.title')}
                        pictureUrl={`${getAssetsBaseUrl()}/images/staff-member/stjepan.jpg`}
                        description={
                            <Box display="flex" flexDirection="column" gap={2}>
                                <Typography>{t('staffMember.stjepanSabljo.1')}</Typography>
                                <Typography>{t('staffMember.stjepanSabljo.2')}</Typography>
                                <Typography>{t('staffMember.stjepanSabljo.3')}</Typography>
                            </Box>
                        }
                    />

                    <StaffMemberView
                        name={t('staffMember.antonijaRezo.title')}
                        pictureUrl={`${getAssetsBaseUrl()}/images/staff-member/antonija1.jpg`}
                        description={
                            <Box display="flex" flexDirection="column" gap={2}>
                                <Typography>{t('staffMember.antonijaRezo.1')}</Typography>
                                <Typography>{t('staffMember.antonijaRezo.2')}</Typography>
                            </Box>
                        }
                    />
                </Box>
            </Box>
        </>
    );
};

export default StaffMemberPage;
